import {GoalV3} from '@/features/chat/chat.model'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {cancelGoal} from '../services/goal.http'
import {QUERY_KEYS} from './keys'

export const useStopGoalV3 = (onSuccess: (data: GoalV3) => void) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: cancelGoal,
        onSuccess: data => {
            queryClient.setQueriesData({queryKey: [QUERY_KEYS.selectedGoal, data.id.toString()]}, data)
            onSuccess(data)
        }
    })
}
